
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import _ from 'lodash';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Beleg from '@/types/Beleg';
    import Belegposition from '@/types/Belegposition';
    import { Kassaliste } from '@/store/types';
    import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapGetters('authentication', ['impfstelleDetail']),
            ...mapState('kassafuehrung', ['kassaliste', 'loaders']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('kassafuehrung', ['printKassaliste', 'exportKassaliste']),
            ...mapMutations('kassafuehrung', ['setDialogKassaliste']),
        },
    })
    export default class Kassaabschlussliste extends Vue {
        @Prop() visible!: boolean;

        public kassaliste!: Kassaliste;
        public steuersaetze: any[] = [];
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;
        public barsumme = 0;

        protected belegeSum = (sum: number, beleg: Beleg): number => {
            return sum += (!beleg.isStorniert ? beleg.gesamtbetrag ?? 0 : 0);
        };

        public summe(belege: Beleg[]): number {
            if (belege[0].zahlungsart === 'BAR') {
                this.barsumme = belege.reduce(this.belegeSum, 0);
            }
            return belege.reduce(this.belegeSum, 0);
        }

        public isEnabledAufschluesselung(): boolean {
            for (var cnt = 0; cnt < this.kassaliste.belege.length; cnt++) {
                if (!this.kassaliste.belege[cnt].ust) {
                    return false;
                }
            }
            return true;
        }

        public summeNetto(belege: Beleg[], Steuersatz: number): number {
            var nettoSum = 0;
            for (var cnt = 0; cnt < belege.length; cnt++) {
                if (belege[cnt].steuersatz === Steuersatz && belege[cnt].gesamtbetrag && belege[cnt].storniert !== 'j') {
                    nettoSum += belege[cnt].gesamtbetrag / (1 + (Steuersatz / 100));
                }
            }
            return nettoSum;
        }

        public summeSteuer(belege: Beleg[], Steuersatz: number): number {
            var SteuerSum = 0;
            for (var cnt = 0; cnt < belege.length; cnt++) {
                if (belege[cnt].steuersatz === Steuersatz && belege[cnt].gesamtbetrag && belege[cnt].storniert !== 'j') {
                    SteuerSum += belege[cnt].gesamtbetrag - (belege[cnt].gesamtbetrag / (1 + (Steuersatz / 100)));
                }
            }
            return SteuerSum;
        }

        public get gesamt(): number {
            for (var cnt = 0; cnt < this.kassaliste.belege.length; cnt++) {
                if (this.kassaliste.belege[cnt].steuersatz && !this.steuersaetze.includes(this.kassaliste.belege[cnt].steuersatz)) {
                    this.steuersaetze.push(this.kassaliste.belege[cnt].steuersatz as number);
                }
            }
            return this.kassaliste.belege?.reduce(this.belegeSum, 0) ?? 0;
        }

        public get verwaltungsabgaben(): number {
            return this.kassaliste.leistungen?.reduce((sum: number, leistung: Belegposition) => {
                return sum += (!leistung.isStorniert ? leistung.betrag_brutto ?? 0 : 0);
            }, 0) ?? 0;
        }

        public get filteredKassabelege(): { [zahlungsart: string]: Beleg[] } {
            return _.groupBy(this.kassaliste.belege, 'zahlungsart');
        }
    }
